import {
    ChangeDetectionStrategy,
    Component,
    OnInit,
} from '@angular/core';
import {
    FormBuilder,
    FormGroup,
    Validators,
} from '@angular/forms';
import { UiModalComponent } from '@components/ui-modal/ui-modal.component';
import {
    IEnvironment,
    ModalResultType,
} from '@models';
import { EnvironmentService } from '@services';
import { UI_DESCRIPTION_MAX_LENGTH } from '@validators';

import { BehaviorSubject } from 'rxjs';
import { finalize } from 'rxjs/operators';

@Component({
    templateUrl: './environment.modal.html',
    providers: [EnvironmentService],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EnvironmentModalComponent
    extends UiModalComponent<IEnvironment>
    implements OnInit {

    public form!: FormGroup;
    public loading$ = new BehaviorSubject(false);

    private _environmentService = this._injector.get<EnvironmentService>(EnvironmentService);

    ngOnInit() {
        this.form = this._injector.get<FormBuilder>(FormBuilder).group({
            'name': [
                this.context.data.name,
                Validators.compose([
                    Validators.required,
                    Validators.maxLength(100),
                ]),
            ],
            'description': [
                this.context.data.description,
                Validators.maxLength(UI_DESCRIPTION_MAX_LENGTH),
            ],
        });
    }

    onSubmit() {
        if (
            !this.form.valid ||
            this.loading$.value
        ) {
            return;
        }

        Object.assign(this.context.data, this.form.value);

        this.loading$.next(true);

        if (this.context.isNewEntry) {
            this._environmentService.add(this.context.data)
                .pipe(
                    finalize(
                        () => this.loading$.next(false),
                    ),
                )
                .subscribe((environment: IEnvironment) => {
                    this._dialogRef.close({
                        type: ModalResultType.Add,
                        data: environment,
                    });
                });
        } else {
            this._environmentService.update(this.context.data.id, this.context.data)
                .pipe(
                    finalize(
                        () => this.loading$.next(false),
                    ),
                )
                .subscribe(() => {
                    this._dialogRef.close({
                        type: ModalResultType.Update,
                        data: this.context.data,
                    });
                });
        }
    }
}
